export default "__VITE_ASSET__4e44b34d__"